/**
 * Canonical step-type order. Copied from
 * mini-apps/action-view/grouping.ts:14-36 (STEP_TYPE_ORDER, stepTypeRank) —
 * never imported (mini-apps/CLAUDE.md: core/web cannot import mini-app
 * code). Verb labels live in `@shared/flow/signal-verification`'s
 * `stepLabelFor`.
 *
 * Single source of truth for step-type ordering in the Signals tab, shared
 * by `prioritizeSignals.ts`'s ranking comparator and (eventually) any
 * group-ordering by step type — see grouping.ts's own module doc for why
 * connect sorts before message (a deliberate flip from an earlier
 * size-based display, Spencer 2026-07-30).
 */

// ── Canonical step-type order ────────────────────────────────────────────────
export const STEP_TYPE_ORDER = ['call', 'manual email', 'linkedin connect', 'linkedin message'] as const;

/** Rank sentinel for unknown/absent step types — sorts strictly after all known ones. */
const UNKNOWN_STEP_TYPE_RANK = STEP_TYPE_ORDER.length;

/**
 * Position of a `signal_tactic` value in the canonical order. Normalizes
 * (lowercase + trim) then substring-matches so free-form Gong labels land on
 * the right rank. LinkedIn connect is checked before message; unknown/null/
 * empty/auto-email → a large sentinel so they sort last.
 */
export function stepTypeRank(stepType: string | null | undefined): number {
  const s = (stepType ?? '').toLowerCase().trim();
  if (!s) return UNKNOWN_STEP_TYPE_RANK;
  if (s.includes('call')) return 0; // 'call'
  if (s.includes('linkedin')) {
    // connect (index 2) before message (index 3); a bare "linkedin" → connect.
    return s.includes('message') ? 3 : 2;
  }
  if (s.includes('email') && !s.includes('auto')) return 1; // 'manual email'
  return UNKNOWN_STEP_TYPE_RANK;
}
